import { useState, useCallback } from "react";
import { useAppContext } from "./useAppContext";
import { useMessage } from "./useMessage";

export const useSelectedFontFamily = () => {
	const { editor } = useAppContext();

	const [selectedFontFamily, setSelectedFontFamily] = useState(() => {
		const selectedZone = editor.selection.getCurrentZone();
		return eXpress.core.isAnyTextZone(selectedZone)
			? selectedZone.textSettings.fontFamily
			: undefined;
	});

	useMessage(
		useCallback(() => {
			// Didn't choose to check message type, because following code is fast enough and will be always correct
			// Didn't use zone from state because that state can still be the old value (if selection and value changes together)
			const selectedZone = editor.selection.getCurrentZone();
			setSelectedFontFamily(
				eXpress.core.isAnyTextZone(selectedZone)
					? selectedZone.textSettings.fontFamily
					: undefined,
			);
		}, [editor]),
	);

	return selectedFontFamily;
};
